document.addEventListener('DOMContentLoaded', () => {
  const autoplayDeferreds = document.querySelectorAll('deferred-media[data-autoplay="true"]');

  autoplayDeferreds.forEach((mediaEl) => {
    // Load the real video content from its template
    if (typeof mediaEl.loadContent === 'function') {
      mediaEl.loadContent(false);
    } else {
      const tpl = mediaEl.querySelector('template');
      if (tpl && tpl.content && tpl.content.firstElementChild && !mediaEl.querySelector('video,iframe')) {
        mediaEl.appendChild(tpl.content.firstElementChild.cloneNode(true));
      }
    }

    // Remove the poster overlay
    const poster = mediaEl.querySelector('.deferred-media__poster');
    if (poster) poster.remove();

    // Once the video exists, try to play it
    const tryPlay = () => {
      const vid = mediaEl.querySelector('video');
      if (vid) {
        vid.muted = true;
        vid.playsInline = true;
        vid.autoplay = true;
        vid.loop = true;
        vid.controls = false;
        try { vid.load(); } catch (e) {}
        vid.play().catch(() => {});
      }
    };

    // Wait a short delay so DOM finishes injecting the real video
    setTimeout(tryPlay, 400);
  });
});
